import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { generateLeadQualification } from '../../lib/openai';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiUserCheck, FiLoader } = FiIcons;

function LeadQualifier({ lead }) {
  const [qualification, setQualification] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const analyzeLeadQuality = async () => {
    setIsLoading(true);
    try {
      const result = await generateLeadQualification(lead);
      setQualification(result);
    } catch (error) {
      console.error('Error qualifying lead:', error);
      setQualification('Failed to analyze lead. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white p-4 sm:p-6 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
        <SafeIcon icon={FiUserCheck} className="w-5 h-5 mr-2 text-primary-500" />
        AI Lead Qualification
      </h3>
      
      <div className="bg-gray-50 p-3 rounded-lg mb-4">
        <div className="grid grid-cols-2 gap-2 text-sm">
          <p className="text-gray-500">Name:</p>
          <p className="font-medium">{lead.firstName} {lead.lastName}</p>
          
          <p className="text-gray-500">Interest:</p>
          <p className="font-medium">{lead.interestedVehicle || 'Not specified'}</p>
          
          <p className="text-gray-500">Budget:</p>
          <p className="font-medium">{lead.budget ? `$${lead.budget.toLocaleString()}` : 'Not specified'}</p>
          
          <p className="text-gray-500">Source:</p>
          <p className="font-medium">{lead.source || 'Not specified'}</p>
        </div>
      </div>
      
      <motion.button
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        onClick={analyzeLeadQuality}
        disabled={isLoading}
        className="w-full bg-primary-600 text-white py-2 rounded-lg font-medium hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2 mb-4 disabled:opacity-50"
      >
        {isLoading ? (
          <>
            <SafeIcon icon={FiLoader} className="w-4 h-4 animate-spin" />
            <span>Analyzing...</span>
          </>
        ) : (
          <>
            <SafeIcon icon={FiUserCheck} className="w-4 h-4" />
            <span>Analyze Lead Quality</span>
          </>
        )}
      </motion.button>
      
      {qualification && (
        <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
          <h4 className="font-medium text-gray-900 mb-2">Lead Analysis</h4>
          <p className="text-sm whitespace-pre-wrap">{qualification}</p>
        </div>
      )}
    </div>
  );
}

export default LeadQualifier;